function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { deepClone, getUniqueKey } from '@bydesign-ui/utils';
import { NestWatcher } from '../../../models/nest-watcher';
import { getNestWatchPath } from '../util';
import { FormGroup } from './FormGroup';
export var FormRepeat = function (_FormGroup) {
  _inherits(FormRepeat, _FormGroup);

  var _super = _createSuper(FormRepeat);

  function FormRepeat(form, scope, options) {
    var _this;

    _classCallCheck(this, FormRepeat);

    _this = _super.call(this, form, scope, {
      field: options.field,
      defaultValue: options.defaultValue || []
    });
    _this.parts = {};
    _this.partGroups = {};
    _this.partKeys = [];
    _this.itemInitValue = options.itemInitValue;

    _this.initRepeat();

    return _this;
  }

  _createClass(FormRepeat, [{
    key: "reset",
    value: function reset() {
      this.cleanRepeatItems();
    }
  }, {
    key: "isRepeat",
    value: function isRepeat() {
      return true;
    }
  }, {
    key: "getRepeatGroup",
    value: function getRepeatGroup(key) {
      return this.partGroups[key];
    }
  }, {
    key: "appendRepeatItem",
    value: function appendRepeatItem(data) {
      var path = this.getPath();
      var value = this.form.getPathValue(path);
      var pathValue = value.concat(data == null ? this.getItemInitValue() : data);
      this.form.setPathValue(path, pathValue);
    }
  }, {
    key: "insertBeforeRepeatItem",
    value: function insertBeforeRepeatItem(key, data) {
      var path = this.getPath();
      var value = this.form.getPathValue(path);
      var index = Math.max(this.node.getIndex(this.parts[key]), 0);
      var list = value.slice(0);
      list.splice(index, 0, data == null ? this.getItemInitValue() : data);
      this.form.setPathValue(path, list);
    }
  }, {
    key: "insertAfterRepeatItem",
    value: function insertAfterRepeatItem(key, data) {
      var path = this.getPath();
      var value = this.form.getPathValue(path);
      var index = Math.max(this.node.getIndex(this.parts[key]) + 1, value.length);
      var list = value.slice(0);
      list.splice(index, 0, data == null ? this.getItemInitValue() : data);
      this.form.setPathValue(path, list);
    }
  }, {
    key: "insertRepeatItem",
    value: function insertRepeatItem(key, data) {
      var path = this.getPath();
      var value = this.form.getPathValue(path);
      var list = value.slice(0);
      var index = this.node.getIndex(this.parts[key]);
      list.splice(index, 0, data == null ? this.getItemInitValue() : data);
      this.form.setPathValue(path, list);
    }
  }, {
    key: "removeRepeatItem",
    value: function removeRepeatItem(key) {
      var path = this.getPath();
      var value = this.form.getPathValue(path);
      var list = value.slice(0);
      var index = this.node.getIndex(this.parts[key]);
      list.splice(index, 1);
      this.form.setPathValue(path, list, false, {
        removeRepeat: true
      });
    }
  }, {
    key: "cleanRepeatItems",
    value: function cleanRepeatItems() {
      var path = this.getPath();
      this.form.setPathValue(path, []);
    }
  }, {
    key: "sortRepeatItem",
    value: function sortRepeatItem(fromKey, toKey) {
      var path = this.getPath();
      var value = this.form.getPathValue(path);
      var list = value.slice(0);
      var from = this.node.getIndex(this.parts[fromKey]);
      var to = this.node.getIndex(this.parts[toKey]);

      if (from === to) {
        return;
      }

      if (from < to) {
        to--;
      }

      list.splice.apply(list, [to, 0].concat(_toConsumableArray(list.splice(from, 1))));
      this.form.setPathValue(path, list);
    }
  }, {
    key: "getRepeatInfo",
    value: function getRepeatInfo() {
      var group = this.getGroupInfo();
      return _objectSpread(_objectSpread({}, group), {}, {
        keys: this.partKeys,
        datasource: this.form.getPathValue(this.getPath())
      });
    }
  }, {
    key: "initRepeat",
    value: function initRepeat() {
      var _this2 = this;

      var path = this.getPath();
      this.form.absoluteWatch(this.id, [NestWatcher.combineKeys(getNestWatchPath(this.node))], function (pathArr, flags) {
        var removeRepeat = Boolean(flags.removeRepeat);

        if (removeRepeat) {
          var check = Boolean(pathArr.length === 1 && pathArr[0] === 'model.' + path);
          if (check) _this2.updateBrickParts();
        } else {
          _this2.updateBrickParts();
        }
      });
      this.updateBrickParts(true);
    }
  }, {
    key: "updateBrickParts",
    value: function updateBrickParts() {
      var _this3 = this;

      var isSilent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var newPartList = this.getPartList();
      Object.keys(this.parts).forEach(function (key) {
        if (!newPartList.includes(key)) {
          _this3.parts[key].remove();

          _this3.partGroups[key].dispose();
        }
      });
      var container = this.node;
      var oldList = container.getChildNodes();
      var newElemList = newPartList.map(function (part) {
        return _this3.parts[part] || _this3.createPartNode(part);
      });
      oldList.forEach(function (item) {
        return item.remove();
      });
      newElemList.forEach(function (elem) {
        return container.appendChild(elem);
      });

      if (!isSilent) {
        this.emit('repaint');
      }
    }
  }, {
    key: "getPartList",
    value: function getPartList() {
      var value = this.form.getPathValue(this.getPath());

      if (!Array.isArray(value)) {
        return [];
      }

      return this.partKeys = value.map(function (item) {
        return getUniqueKey(item);
      });
    }
  }, {
    key: "createPartNode",
    value: function createPartNode(part) {
      var group = this.partGroups[part] = new FormGroup(this.form, this.node, {
        field: part,
        defaultValue: this.itemInitValue,
        repeat: true
      });
      return this.parts[part] = group.getNode();
    }
  }, {
    key: "getItemInitValue",
    value: function getItemInitValue() {
      var fn = this.itemInitValue;
      return typeof fn === 'function' ? fn() : deepClone(fn);
    }
  }]);

  return FormRepeat;
}(FormGroup);